export enum UserRoles {
  ADMINISTRATOR = 1,
  EMPLOYEE = 2,
  CUSTOMER = 3,
  DEALER = 4, // ADMIN
  MANUFACTURER_ADMIN = 5,
  MANUFACTURER_AGENT = 6,
  CUSTOMER_SUPPORT = 7,
  MANAGEMENT_ADMIN = 8,
  MANAGEMENT_AGENT = 9,
  DEALER_AGENT = 10,
}
